import React, { useState } from "react";
import { api } from "@/lib/api";
import { Sparkles, X, Copy, Mail } from "lucide-react";

export default function AIEmailModal({ taskId, onClose, onLog }) {
  const [draft, setDraft] = useState("");
  const [tone, setTone] = useState("formal");
  const [purpose, setPurpose] = useState("update");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  async function generate() {
    setLoading(true); setErr("");
    try {
      const r = await api.post("/ai/generate-email", { task_id: taskId, tone, purpose });
      setDraft(r.data.draft);
    } catch (e) {
      setErr("Could not generate email.");
    } finally { setLoading(false); }
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/30 backdrop-blur-sm" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="card-flat ai-frame w-full max-w-2xl bg-white" data-testid="ai-email-modal">
        <div className="px-6 py-4 border-b border-[var(--line)] flex items-center justify-between">
          <div className="flex items-center gap-2 text-[var(--ai)]">
            <Sparkles size={16} strokeWidth={1.5} />
            <span className="overline">Draft email · Claude Sonnet 4.5</span>
          </div>
          <button data-testid="ai-close" onClick={onClose}><X size={16} strokeWidth={1.5} /></button>
        </div>
        <div className="p-6">
          <div className="flex gap-3 mb-4">
            <div className="flex-1">
              <label className="label-overline">Tone</label>
              <select data-testid="ai-tone" value={tone} onChange={(e) => setTone(e.target.value)} className="input">
                <option value="formal">Formal</option>
                <option value="friendly">Friendly</option>
                <option value="direct">Direct</option>
              </select>
            </div>
            <div className="flex-1">
              <label className="label-overline">Purpose</label>
              <select data-testid="ai-purpose" value={purpose} onChange={(e) => setPurpose(e.target.value)} className="input">
                <option value="update">Progress update</option>
                <option value="request">Request documents</option>
                <option value="reminder">Deadline reminder</option>
                <option value="completion">Task completed</option>
              </select>
            </div>
          </div>
          <button data-testid="ai-generate" onClick={generate} disabled={loading} className="btn-primary w-full mb-4 flex items-center justify-center gap-2">
            <Sparkles size={14} strokeWidth={1.5} /> {loading ? "Drafting…" : (draft ? "Regenerate" : "Generate draft")}
          </button>
          {err && <div className="text-sm text-[var(--err)] mb-2">{err}</div>}
          <textarea
            data-testid="ai-draft"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Your AI-drafted email will appear here…"
            className="input font-display text-sm leading-relaxed"
            rows={14}
          />
        </div>
        <div className="px-6 py-4 border-t border-[var(--line)] flex justify-between">
          <button data-testid="ai-copy" onClick={() => { navigator.clipboard.writeText(draft); }} className="btn-ghost flex items-center gap-2"><Copy size={14} strokeWidth={1.5} /> Copy</button>
          <button data-testid="ai-log" disabled={!draft} onClick={() => onLog(draft)} className="btn-primary flex items-center gap-2"><Mail size={14} strokeWidth={1.5} /> Log as sent</button>
        </div>
      </div>
    </div>
  );
}
